var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tbody", [
    _c("tr", { staticClass: "cursor-pointer w-max" }, [
      _c("td", { staticClass: "table-cell w-30" }, [
        _vm.isAdmin
          ? _c(
              "div",
              { staticClass: "px-2 py-4 text-left relative" },
              [
                !_vm.newContractor
                  ? _c("CardInfoChip", {
                      staticClass: "self-center",
                      attrs: { message: "Company member" },
                    })
                  : _vm._e(),
                _vm.newContractor
                  ? _c("CardInfoChip", {
                      staticClass: "self-center",
                      attrs: { message: "Not a company member", red: "" },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("td", { staticClass: "table-cell w-28" }, [
        _c("div", { staticClass: "px-2 py-4 text-left" }, [
          _c(
            "span",
            { staticClass: "leading-5 customText text-left relative" },
            [_vm._v(_vm._s(_vm.contractorName))]
          ),
        ]),
      ]),
      _c("td", { staticClass: "table-cell text-left" }, [
        _vm.contractorLocation.length > 0 && _vm.contractorLocation !== `.`
          ? _c(
              "div",
              { staticClass: "px-2 py-4 text-left" },
              [
                _c("CardBodyItem", {
                  attrs: {
                    content: _vm.contractorLocation,
                    textStyleClasses: "customText",
                    additionalClass: `block adjustNewMargin`,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("td", { staticClass: "table-cell w-36" }, [
        _vm.contractorJobTitle.length > 0 && _vm.contractorJobTitle !== `.`
          ? _c(
              "div",
              { staticClass: "px-2 py-4 text-left" },
              [
                _c("CardBodyItem", {
                  attrs: {
                    content: _vm.contractorJobTitle,
                    textStyleClasses: "customText",
                    additionalClass: `block adjustNewMargin`,
                  },
                }),
              ],
              1
            )
          : _c("div", { staticClass: "px-2 py-4 text-left" }, [_vm._v("n/a")]),
      ]),
      _c("td", { staticClass: "table-cell w-36" }, [
        _c(
          "div",
          { staticClass: "px-2 py-4 text-left" },
          [
            _vm.contractorRates
              ? _c("CardBodyItem", {
                  attrs: {
                    content: _vm.contractorRates,
                    textStyleClasses: "customText",
                    additionalClass: `block adjustNewMargin`,
                  },
                })
              : _c("div", { staticClass: "px-2 py-4 text-left" }, [
                  _vm._v("n/a"),
                ]),
          ],
          1
        ),
      ]),
      _c("td", { staticClass: "table-cell w-44" }, [
        _c(
          "div",
          { staticClass: "px-2 py-4 text-left" },
          [
            _c(
              "CardBodyItem",
              {
                staticClass:
                  "w-44 mr-5 defaultLabelContainer flex-grow customText",
                attrs: { additionalClass: `block adjustNewMargin` },
              },
              [
                _vm.contractorSkills.length
                  ? _c("ItemChipsWithMore", {
                      attrs: {
                        items: _vm.contractorSkills,
                        navigateTo: _vm.contractorLink,
                      },
                    })
                  : _c("div", { staticClass: "px-2 py-4 text-left" }, [
                      _vm._v("n/a"),
                    ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("td", { staticClass: "table-cell w-36" }, [
        _c(
          "div",
          [
            _c("CardBodyItem", {
              attrs: {
                content: _vm.profileConfirmed,
                additionalClass: `block adjustNewMargin`,
              },
            }),
          ],
          1
        ),
      ]),
      _c("td", { staticClass: "table-cell w-40" }, [
        _c(
          "div",
          [
            _vm.requestedDate
              ? _c("CardBodyItem", {
                  attrs: {
                    content: _vm.requestedDate,
                    additionalClass: `block adjustNewMargin`,
                  },
                })
              : _c("div", { staticClass: "px-2 py-4 text-left" }, [
                  _vm._v("n/a"),
                ]),
          ],
          1
        ),
      ]),
      _c("td", { staticClass: "table-cell w-40" }, [
        _c("div", { staticClass: "w-20" }, [
          _vm.isAdmin
            ? _c(
                "div",
                [
                  _c("MoreActions", {
                    staticClass: "relative customTop",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action-buttons",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex flex-col bg-white" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "actionLink",
                                      on: {
                                        click: _vm.handleApproveConfirmation,
                                      },
                                    },
                                    [_vm._v(" Approve ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "actionLink",
                                      on: {
                                        click: _vm.handleDeclineConfirmation,
                                      },
                                    },
                                    [_vm._v(" Decline ")]
                                  ),
                                  _vm.showAddToCompany
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: {
                                            click:
                                              _vm.handleAddToCompanyConfirmation,
                                          },
                                        },
                                        [_vm._v(" Add To Company ")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2409147963
                    ),
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "flex items-center h-10 w-full" },
                [
                  _c("RemoveManagerContractorRequest", {
                    staticClass: "ml-auto",
                    attrs: {
                      buttonSize: "no",
                      buttonVariant: "linkButton",
                      contractorId: _vm.contractorId,
                      managerId: _vm.managerId,
                    },
                    on: {
                      requestRemoved: function ($event) {
                        return _vm.$emit("refetch")
                      },
                    },
                  }),
                ],
                1
              ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }